import { render } from "./UserModal.vue?vue&type=template&id=6d2739b4&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"

import "./UserModal.vue?vue&type=style&index=0&id=6d2739b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2739b4"]])

export default __exports__